export { ReferralTermsCard } from "./ReferralTermsCard"
export type { ReferralTermsCardProps } from "./ReferralTermsCard"
